import React, {useEffect, useRef, useState} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {getLanguage, t} from 'react-switch-lang';
import SelectInfinite from '../../../../../components/FormFields/SelectInfinite';
import * as yup from 'yup';
import {Col, Row, Spinner} from 'react-bootstrap';
import {yupResolver} from '@hookform/resolvers';
import InputText from '../../../../../components/FormFields/InputText';
import InputDate from '../../../../../components/FormFields/inputDate/InputDate';
import TextArea from '../../../../../components/FormFields/Textarea';
import {format} from 'date-fns';
import {
  createITFForm,
  editITFForm,
  getITFForm,
  getITFRiskAssessmentLevel,
} from '../../../../../services/externalizations/itfSecurityService';
import {Toast} from '../../../../../utils/sweetAlert';
import {useParams} from 'react-router-dom';
import allowedFileTypes from '../../../../../utils/allowedFileTypes';
import {
  deleteFile, downloadFile,
  uploadITFFormFile
} from '../../../../../services/externalizations/fileUploadService';
import {
  customStyles,
  handleCancelExternalization,
  isUserReviewer, statusesOfVerification,
  yesNoOptions,
} from '../../../../../utils/externalizationFormOptions';
import FileUploadSection from '../../../../../components/FileUploadSection/FileUploadSection';
import Swal from 'sweetalert2';
import {Tooltip} from 'antd';
import {InfoCircleOutlined} from '@ant-design/icons';
import SelectList from '../../../../../components/select/SelectList';
import {useExternalizationContext} from '../../../../../contexts/ExternalizationContext';
import {useUserContext} from '../../../../../contexts/UserContext';
import VerifyExternalizationModal from '../../../components/verifyExternalizationModal/VerifyExternalizationModal';
import FormActionButtons from '../../../components/formActionButtons/FormActionButtons';

function ITFSecurity({cycleId, isLastCycle, isEditAllowedByStatus, externalizationFormConfigData}) {
  const [disabled, setDisabled] = useState(false);
  const [itfFormId, setItfFormId] = useState();
  const [loading,setLoading] = useState(false);
  const [isReview,setIsReview] = useState(false);
  const [populated,setPopulated] = useState(false);
  const [showEditBtn,setShowEditBtn] = useState(false);
  const [defaultData, setDefaultData] = useState([]);
  const [totalRiskAssessment, setTotalRiskAssessment] = useState([]);
  const [riskDescription, setRiskDescription] = useState('');
  const [files, setFiles] = useState({
    processControlAndServiceAvailabilityRiskLevel: null,
    businessContinuityRiskLevel: null,
    regulatoryAndAuditAccessRiskLevel: null,
    confidentialityAndDataProtectionRiskLevel: null,
    dataLossAndUnauthorizedAccessRiskLevelFile: null,
    serviceProviderReplacementFeasibilityLevelFile: null,
    serviceProviderDependencyLevelFile: null,
    concentrationRiskLevelFile: null,
    changeManagementRiskLevelFile: null,
    thirdPartyAccessControlRiskLevelFile: null,
    flexibilityAndTechnicalLimitationRiskLevelFile: null,
    technologyAdaptabilityRiskLevelFile: null,
    serviceMonitoringAndMaintenanceRiskLevelFile: null,
    technicalOversightFeasibilityRiskLevelFile: null,
  });
  const hasReset = useRef(false);
  const {id} = useParams();
  const [edit, setEdit] = useState(showEditBtn);
  const externalizationConfigData = useExternalizationContext();
  const user = useUserContext()
  const [responsibleUserId, setResponsibleUserId] = useState()
  const [verifyModalOpen, setVerifyModalOpen] = useState(false);
  const [verificationStatus, setVerificationStatus]= useState('')
  const canVerify = verificationStatus === 'PENDING'
  const userCanVerifyForm = user?.id === responsibleUserId
  const toggleVerifyModal = () => setVerifyModalOpen(prev => !prev);
  const schema = yup.object().shape({
    processingDate: yup.date()
      .nullable()
      .typeError(t('message.fieldRequired'))
      .required(t('message.fieldRequired')),
    processControlAndServiceAvailabilityRiskLevel: yup.object().nullable().required(t('message.fieldRequired')),
    businessContinuityRiskLevel: yup.object().nullable().required(t('message.fieldRequired')),
    regulatoryAndAuditAccessRiskLevel: yup.object().nullable().required(t('message.fieldRequired')),
    confidentialityAndDataProtectionRiskLevel: yup.object().nullable().required(t('message.fieldRequired')),
    dataLossAndUnauthorizedAccessRiskLevel: yup.object().nullable().required(t('message.fieldRequired')),
    serviceProviderReplacementFeasibilityLevel: yup.object().nullable().required(t('message.fieldRequired')),
    serviceProviderDependencyLevel: yup.object().nullable().required(t('message.fieldRequired')),
    concentrationRiskLevel: yup.object().nullable().required(t('message.fieldRequired')),
    changeManagementRiskLevel: yup.object().nullable().required(t('message.fieldRequired')),
    thirdPartyAccessControlRiskLevel: yup.object().nullable().required(t('message.fieldRequired')),
    flexibilityAndTechnicalLimitationRiskLevel: yup.object().nullable().required(t('message.fieldRequired')),
    technologyAdaptabilityRiskLevel: yup.object().nullable().required(t('message.fieldRequired')),
    serviceMonitoringAndMaintenanceRiskLevel: yup.object().nullable().required(t('message.fieldRequired')),
    technicalOversightFeasibilityRiskLevel: yup.object().nullable().required(t('message.fieldRequired')),
    comment: yup
      .string()
      .trim()
      .max(30000, t('message.max', {max: 30000})),
    answers678CoCreatedWithProposer: yup.object().nullable(),

    processControlAndServiceAvailabilityRiskLevelDescription: yup
      .string()
      .max(30000, t('message.max', {max: 30000})),
    businessContinuityRiskLevelDescription: yup
      .string()
      .max(30000, t('message.max', {max: 30000})),
    regulatoryAndAuditAccessRiskLevelDescription: yup
      .string()
      .max(30000, t('message.max', {max: 30000})),
    confidentialityAndDataProtectionRiskLevelDescription: yup
      .string()
      .max(30000, t('message.max', {max: 30000})),
    dataLossAndUnauthorizedAccessRiskLevelDescription: yup
      .string()
      .max(30000, t('message.max', {max: 30000})),
    serviceProviderReplacementFeasibilityLevelDescription: yup
      .string()
      .max(30000, t('message.max', {max: 30000})),
    serviceProviderDependencyLevelDescription: yup
      .string()
      .max(30000, t('message.max', {max: 30000})),
    concentrationRiskLevelDescription: yup
      .string()
      .max(30000, t('message.max', {max: 30000})),
    changeManagementRiskLevelDescription: yup
      .string()
      .max(30000, t('message.max', {max: 30000})),
    thirdPartyAccessControlRiskLevelDescription: yup
      .string()
      .max(30000, t('message.max', {max: 30000})),
    flexibilityAndTechnicalLimitationRiskLevelDescription: yup
      .string()
      .max(30000, t('message.max', {max: 30000})),
    technologyAdaptabilityRiskLevelDescription: yup
      .string()
      .max(30000, t('message.max', {max: 30000})),
    serviceMonitoringAndMaintenanceRiskLevelDescription: yup
      .string()
      .max(30000, t('message.max', {max: 30000})),
    technicalOversightFeasibilityRiskLevelDescription: yup
      .string()
      .max(30000, t('message.max', {max: 30000})),
  });
  const methods = useForm({
    resolver: yupResolver(schema),
  });
  const {handleSubmit, setValue, watch, reset} = methods;
  const lang = getLanguage();
  const processControlAndServiceAvailabilityRiskLevel = watch('processControlAndServiceAvailabilityRiskLevel');
  const businessContinuityRiskLevel = watch('businessContinuityRiskLevel');
  const regulatoryAndAuditAccessRiskLevel = watch('regulatoryAndAuditAccessRiskLevel');
  const confidentialityAndDataProtectionRiskLevel = watch('confidentialityAndDataProtectionRiskLevel');
  const dataLossAndUnauthorizedAccessRiskLevel = watch('dataLossAndUnauthorizedAccessRiskLevel');
  const serviceProviderReplacementFeasibilityLevel = watch('serviceProviderReplacementFeasibilityLevel');
  const serviceProviderDependencyLevel = watch('serviceProviderDependencyLevel');
  const concentrationRiskLevel = watch('concentrationRiskLevel');
  const changeManagementRiskLevel = watch('changeManagementRiskLevel');
  const thirdPartyAccessControlRiskLevel = watch('thirdPartyAccessControlRiskLevel');
  const flexibilityAndTechnicalLimitationRiskLevel = watch('flexibilityAndTechnicalLimitationRiskLevel');
  const technologyAdaptabilityRiskLevel = watch('technologyAdaptabilityRiskLevel');
  const serviceMonitoringAndMaintenanceRiskLevel = watch('serviceMonitoringAndMaintenanceRiskLevel');
  const technicalOversightFeasibilityRiskLevel = watch('technicalOversightFeasibilityRiskLevel');
  const itfSecurityOverallRiskAssessmentLevel = watch('itfSecurityOverallRiskAssessmentLevel');

  const submitForm = async  (data) => {
    const formatProcessingDate = format(new Date(data?.processingDate), 'yyyy-MM-dd');
    setDisabled(true);

    const dataToSubmit = {
      ...(edit && {
        id: defaultData?.id ? defaultData?.id : itfFormId,
      }),
      processingDate: formatProcessingDate,
      answers678CoCreatedWithProposer: data?.answers678CoCreatedWithProposer?.value,
      comment: data?.comment,
      processControlAndServiceAvailabilityRiskLevel: {id: data?.processControlAndServiceAvailabilityRiskLevel?.value},
      processControlAndServiceAvailabilityRiskLevelDescription: data?.processControlAndServiceAvailabilityRiskLevelDescription,
      regulatoryAndAuditAccessRiskLevel: {id: data?.regulatoryAndAuditAccessRiskLevel?.value},
      regulatoryAndAuditAccessRiskLevelDescription: data?.regulatoryAndAuditAccessRiskLevelDescription,
      businessContinuityRiskLevel: {id: data?.businessContinuityRiskLevel?.value},
      businessContinuityRiskLevelDescription: data?.businessContinuityRiskLevelDescription,
      confidentialityAndDataProtectionRiskLevel: {id: data?.confidentialityAndDataProtectionRiskLevel?.value},
      confidentialityAndDataProtectionRiskLevelDescription: data?.confidentialityAndDataProtectionRiskLevelDescription,
      dataLossAndUnauthorizedAccessRiskLevel: {id: data?.dataLossAndUnauthorizedAccessRiskLevel?.value},
      dataLossAndUnauthorizedAccessRiskLevelDescription: data?.dataLossAndUnauthorizedAccessRiskLevelDescription,
      serviceProviderReplacementFeasibilityLevel: {id: data?.serviceProviderReplacementFeasibilityLevel?.value},
      serviceProviderReplacementFeasibilityLevelDescription: data?.serviceProviderReplacementFeasibilityLevelDescription,
      serviceProviderDependencyLevel: {id: data?.serviceProviderDependencyLevel?.value},
      serviceProviderDependencyLevelDescription: data?.serviceProviderDependencyLevelDescription,
      concentrationRiskLevel: {id: data?.concentrationRiskLevel?.value},
      concentrationRiskLevelDescription: data?.concentrationRiskLevelDescription,
      changeManagementRiskLevel: {id: data?.changeManagementRiskLevel?.value},
      changeManagementRiskLevelDescription: data?.changeManagementRiskLevelDescription,
      thirdPartyAccessControlRiskLevel: {id: data?.thirdPartyAccessControlRiskLevel?.value},
      thirdPartyAccessControlRiskLevelDescription: data?.thirdPartyAccessControlRiskLevelDescription,
      flexibilityAndTechnicalLimitationRiskLevel: {id: data?.flexibilityAndTechnicalLimitationRiskLevel?.value},
      flexibilityAndTechnicalLimitationRiskLevelDescription: data?.flexibilityAndTechnicalLimitationRiskLevelDescription,
      technologyAdaptabilityRiskLevel: {id: data?.technologyAdaptabilityRiskLevel?.value},
      technologyAdaptabilityRiskLevelDescription: data?.technologyAdaptabilityRiskLevelDescription,
      serviceMonitoringAndMaintenanceRiskLevel: {id: data?.serviceMonitoringAndMaintenanceRiskLevel?.value},
      serviceMonitoringAndMaintenanceRiskLevelDescription: data?.serviceMonitoringAndMaintenanceRiskLevelDescription,
      technicalOversightFeasibilityRiskLevel: {id: data?.technicalOversightFeasibilityRiskLevel?.value},
      technicalOversightFeasibilityRiskLevelDescription: data?.technicalOversightFeasibilityRiskLevelDescription,
      itfSecurityOverallRiskAssessmentLevel: {id: data?.itfSecurityOverallRiskAssessmentLevel?.value},
      formConfig: externalizationFormConfigData,
      populated: true,
      cycle: {id: parseInt(cycleId)},
      userInCharge: {id: externalizationFormConfigData?.defaultDepartment?.userInChargeForExternalizationId},
      responsibleUser: {id: externalizationFormConfigData?.defaultDepartment?.userResponsibleForExternalizationId},

    };
    if (edit) {
      try{
        const res = await editITFForm(defaultData?.id ? defaultData?.id : itfFormId, dataToSubmit)
        if (res?.status === 200) {
          Toast.fire({
            title: t('message.updateSuccess2', {
              entity: t('externalization.ITFSecurityForm.ITFSecurity'),
            }),
            icon: 'success',
          });
          const newVerificationStatus = res?.data?.verificationStatus;
          if (newVerificationStatus && newVerificationStatus !== verificationStatus) {
            setTimeout(() => {
              window.location.reload();
            }, 800);
          } else {
            setVerificationStatus(newVerificationStatus);
            setDisabled(true);
          }
        }
        setDisabled(true);
      } catch (err){
        if (err?.response?.data?.code === 'responsible-user-for-externalization-is-missing') {
          Swal.fire({
            text:
              lang === 'eng'
                ? err.response.data.description
                : t('message.responsibleUserForExternalizationMissing'),
            icon: 'error',
          });
          setDisabled(false)
          setEdit(false)
        } else {
          Toast.fire({
            title: t('message.errorApi'),
            icon: 'error',
          });
        }
      }
    } else {
      try {
        const response = await createITFForm(dataToSubmit)
        if (response?.status === 201) {
          Toast.fire({
            title: t('message.addSuccess2', {
              entity: t('externalization.ITFSecurityForm.ITFSecurity'),
            }),
            icon: 'success',
          });
          setDisabled(true);
          setEdit(true);
          setIsReview(true);
          setVerificationStatus('PENDING')
          setItfFormId(response?.data?.id)
          setResponsibleUserId(externalizationFormConfigData?.defaultDepartment?.userResponsibleForExternalizationId);
        }
      } catch (err) {
        if (err?.response?.data?.code === 'responsible-user-for-externalization-is-missing') {
          Swal.fire({
            text:
              lang === 'eng'
                ? err?.response?.data?.description
                : t('message.responsibleUserForExternalizationMissing'),
            icon: 'error',
          });
          setDisabled(false)
          setEdit(false)
        } else {
          Toast.fire({
            title: t('message.errorApi'),
            icon: 'error',
          });
        }
      }
    }
  };
  const values = [
    processControlAndServiceAvailabilityRiskLevel?.value,
    businessContinuityRiskLevel?.value,
    regulatoryAndAuditAccessRiskLevel?.value,
    confidentialityAndDataProtectionRiskLevel?.value,
    dataLossAndUnauthorizedAccessRiskLevel?.value,
    serviceProviderReplacementFeasibilityLevel?.value,
    serviceProviderDependencyLevel?.value,
    concentrationRiskLevel?.value,
    changeManagementRiskLevel?.value,
    thirdPartyAccessControlRiskLevel?.value,
    flexibilityAndTechnicalLimitationRiskLevel?.value,
    technologyAdaptabilityRiskLevel?.value,
    serviceMonitoringAndMaintenanceRiskLevel?.value,
    technicalOversightFeasibilityRiskLevel?.value,
  ].filter(v => v != null);
  const rawMaxValue = values.length ? Math.max(...values) : null;
  const maxValue = rawMaxValue != null ? rawMaxValue - 1 : null;
  useEffect(() => {
    async function fetchRiskLevels() {
      const {data} = await getITFRiskAssessmentLevel();
      const validLevels = data.filter(r => r.value >= 0 && r.value <= 2);
      setTotalRiskAssessment(validLevels);
    }
    fetchRiskLevels();
  }, []);

  function getRiskAssessmentDTO(riskValue, riskLevelList) {
    return riskLevelList.find(r => r.value === riskValue);
  }

  useEffect(() => {
    if (maxValue != null && totalRiskAssessment.length > 0) {
      const dto = getRiskAssessmentDTO(maxValue, totalRiskAssessment);
      if (dto) {
        const transformed = {
          value: dto.id,
          label: lang === 'mne' ? dto.name : dto.nameEn,
        };
        setValue('itfSecurityOverallRiskAssessmentLevel', transformed);
      }
    }
  }, [processControlAndServiceAvailabilityRiskLevel,
    businessContinuityRiskLevel,
    regulatoryAndAuditAccessRiskLevel,
    confidentialityAndDataProtectionRiskLevel,
    dataLossAndUnauthorizedAccessRiskLevel,
    serviceProviderReplacementFeasibilityLevel,
    serviceProviderDependencyLevel,
    concentrationRiskLevel,
    changeManagementRiskLevel,
    thirdPartyAccessControlRiskLevel,
    flexibilityAndTechnicalLimitationRiskLevel,
    technologyAdaptabilityRiskLevel,
    serviceMonitoringAndMaintenanceRiskLevel,
    technicalOversightFeasibilityRiskLevel, totalRiskAssessment]);
  useEffect(() => {
    if (itfSecurityOverallRiskAssessmentLevel && totalRiskAssessment.length > 0) {
      const matchedRisk = totalRiskAssessment.find(
        (item) => item.id === itfSecurityOverallRiskAssessmentLevel.value,
      );
      if (matchedRisk) {
        setRiskDescription({
          value: matchedRisk.value,
          label: lang === 'mne' ? matchedRisk.description : matchedRisk.descriptionEn,
        });
      }
    }
  }, [itfSecurityOverallRiskAssessmentLevel, totalRiskAssessment]);
  useEffect(() => {

    async function fetchITFForm() {
      setLoading(true);
      try {
        const res = await getITFForm(cycleId);
        const form = res?.data?.[0] ?? null;
        if (form?.id) {
          setDefaultData(form);
          setPopulated(!!form?.populated);
          setEdit(!!form?.populated);
          setDisabled(!!form?.populated);
          setFiles(form?.files)
          setResponsibleUserId(externalizationFormConfigData?.defaultDepartment?.userResponsibleForExternalizationId)
          setVerificationStatus(form?.verificationStatus)
          setIsReview(!!form?.populated && isUserReviewer(externalizationConfigData,user,'itfSecurityForm'));
          setShowEditBtn(!form?.populated === false || !isUserReviewer(externalizationConfigData,user,'itfSecurityForm'));
          reset({
            processingDate: form?.processingDate ? new Date(form.processingDate) : new Date(),
          });
        } else {
          reset({
            processingDate: new Date(),
          });
          setPopulated(false);
          setEdit(false);
          setDisabled(!isUserReviewer(externalizationConfigData,user,'itfSecurityForm'));
          setFiles(prev => ({
            ...prev,
            ...(form?.files ?? {})
          }));
        }

      } catch (err) {
        console.error('Error loading itf form:', err);
        setPopulated(false);
      } finally {
        setLoading(false);
      }
    }
      fetchITFForm();
  }, [cycleId]);
  const handleFileUpload = async (e, fieldName, slotKey) => {
    const file = e?.target?.files[0];
    if (!file) return null;
    try {
      const formData = new FormData();
      formData.append('file', file);
      const response = await uploadITFFormFile(id, slotKey, formData);
      setFiles(prev => ({
        ...prev,
        [fieldName]: {
          fileName: file?.name,
          id: response?.data?.id,
        }
      }));
      return response;
    } catch (error) {
      console.error("Upload error", error);
    }
  };
  const handleFileUploadExternal = async (newFiles, fieldName, slotKey) => {
    const fileInput = document.getElementById(`upload-${fieldName}`);
    if (!fileInput || !fileInput?.files?.length) return;
    const selectedFile = fileInput?.files[0];
    const existingFile = files[fieldName];
    if (existingFile?.id) {
      try {
        await deleteFile(existingFile?.id);
      } catch (err) {
        console.error('error', err);
      }
    }
    const response = await handleFileUpload({ target: { files: [selectedFile] } }, fieldName, slotKey);
    if (response?.status === 201) {
      Toast.fire({
        title: existingFile
          ? t('message.updateSuccess2', { entity: t('externalization.riskProponentForm.file') })
          : t('message.addSuccess2', { entity: t('externalization.riskProponentForm.file') }),
        icon: 'success',
      });
    }
  };
  const removeFile = async (fieldName) => {
    const file = files[fieldName];
    if (!file?.id) return;
    try {
      const r = await deleteFile(file?.id);
      if (r?.status === 204) {
        Toast.fire({
          title: t('message.deleteSuccess2', {
            entity: t('externalization.riskProponentForm.file'),
          }),
          icon: 'success',
        });
        setFiles(prev => ({
          ...prev,
          [fieldName]: null,
        }));
        setDefaultData(prev => ({
          ...prev,
          files: {
            ...prev?.files,
            [fieldName]: null,
          },
        }));
      }
    } catch (error) {
      console.error("error", error);
    }
  };
  const handleDownload = (attachmentId, fileName) => {
    downloadFile(attachmentId,fileName);
  };

if (loading) {
  return (
      <div className="text-center mt-4 mb-4">
        <Spinner animation="border" role="status" />
      </div>
  );
}
  return (<>
    <FormActionButtons
      isReview={isReview}
      edit={edit}
      disabled={disabled}
      isLastCycle={isLastCycle}
      isEditAllowedByStatus={isEditAllowedByStatus}
      userCanVerifyForm={userCanVerifyForm}
      canVerify={canVerify}
      toggleVerifyModal={toggleVerifyModal}
      setDisabled={setDisabled}
    />
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(submitForm)}>
        <Row className='mb-2 w-100'>
          <Col className='col-5 col-xl-3'>
            <label className='label w-100 mt-2'>
              {t('departments.department')}
            </label>
            <SelectInfinite
              api='departments'
              name='departmentInCharge'
              labelKey={lang === 'mne' ? 'name' : 'nameEn'}
              className='select'
              isDisabled={true}
              defaultValue={
                externalizationFormConfigData?.defaultDepartment
                  ? {
                    value: externalizationFormConfigData?.defaultDepartment?.id,
                    label:
                      lang === 'mne'
                        ? externalizationFormConfigData?.defaultDepartment?.name
                        : externalizationFormConfigData?.defaultDepartment?.nameEn,
                  }
                  : null
              }
            />
          </Col>
          <Col className='col-6 col-xl-3'>
            <label className='label w-100 mt-2'>
              {t('externalization.riskProponentForm.date')}
            </label>
            <InputDate
              name='processingDate'
              className={'date-input'}
                defaultValue={new Date()}
              disabled={disabled}
            />
          </Col>
        </Row>
        <Row>
          <Col className='col-6 col-xl-3'>
            <label className='label w-100 mt-2' htmlFor='processControlAndServiceAvailabilityRiskLevel'>
              {t('externalization.ITFSecurityForm.controlLossRisk')}
              <span className="optional register line-height pt-1"><Tooltip
                              title={t('externalization.ITFSecurityForm.controlLossRiskTooltip')}
                              overlayClassName="custom-tooltip"
                              placement="top"><div style={{ cursor: 'default' }}><InfoCircleOutlined /></div></Tooltip></span></label>
            <SelectInfinite
              api='process-control-and-service-availability-risk-levels'
              name='processControlAndServiceAvailabilityRiskLevel'
              placeholder={t('externalization.ITFSecurityForm.placeholder.controlLossRisk')}
              labelKey={lang === 'mne' ? 'name' : 'nameEn'}
              className='select'
              defaultValue={defaultData?.processControlAndServiceAvailabilityRiskLevel ? {
                label: lang === 'mne' ? defaultData?.processControlAndServiceAvailabilityRiskLevel?.name : defaultData?.processControlAndServiceAvailabilityRiskLevel?.nameEn,
                value: defaultData?.processControlAndServiceAvailabilityRiskLevel?.id,
              }
                : null}
              isDisabled={disabled} />
          </Col>
          <Col className='col-6 col-xl-3'>
            <label className='label w-100 mt-2'>
              {t('comments.comment')}
              <span className='optional register line-height'>
                  {t('common.optional')}
                </span>
            </label>
            <TextArea
              name='processControlAndServiceAvailabilityRiskLevelDescription'
              className={`form-control text-area `}
              placeholder={t('placeholder.comment')}
              disabled={disabled}
              defaultValue={defaultData?.processControlAndServiceAvailabilityRiskLevelDescription}
            />
          </Col>
          <Col className='col-6 col-xl-3'>
            <label className="label d-flex align-items-end w-100 mt-2">
              {t('externalization.riskProponentForm.file')}
              <span style={{minWidth: '94%'}} style={{minWidth: '94%'}} className="optional register line-height">{t('common.optional')} </span>
            </label>
            <FileUploadSection
              className={'fileName'}
              fieldName={'processControlAndServiceAvailabilityRiskLevel'}
              key={files?.processControlAndServiceAvailabilityRiskLevel?.id || 'no-file'}
              allowedFileTypes={allowedFileTypes}
              disabled={disabled}
              required={false}
              multiple={false}
              fetchedFiles={defaultData?.files?.processControlAndServiceAvailabilityRiskLevel ?
                {
                  fileName: defaultData?.files?.processControlAndServiceAvailabilityRiskLevel?.fileName,
                  id: defaultData?.files?.processControlAndServiceAvailabilityRiskLevel?.id
                } : [{ id: files?.processControlAndServiceAvailabilityRiskLevel?.id, fileName: files?.processControlAndServiceAvailabilityRiskLevel?.fileName }]
               }
              onDeleteFetchedFile={() => removeFile('processControlAndServiceAvailabilityRiskLevel')}
              onNewFilesChange={(newFiles) => handleFileUploadExternal(newFiles, 'processControlAndServiceAvailabilityRiskLevel', 'process-control-and-service-availability-risk-level')}
              onFileDownload={(id, fileName) => handleDownload(defaultData?.files?.processControlAndServiceAvailabilityRiskLevel?.id, fileName)}
            />
          </Col>
         </Row>
        <Row>
          <Col className='col-6 col-xl-3'>
            <label className='label w-100 mt-2' htmlFor='businessContinuityRiskLevel'>
              {t('externalization.ITFSecurityForm.continuityInterruptionRisk')}
              <span className="optional register line-height pt-1"><Tooltip
                title={t('externalization.ITFSecurityForm.continuityInterruptionRiskTooltip')}
                overlayClassName="custom-tooltip"
                placement="top"><div style={{ cursor: 'default' }}><InfoCircleOutlined /></div></Tooltip></span></label>
            <SelectInfinite
              api='business-continuity-risk-levels'
              name='businessContinuityRiskLevel'
              placeholder={t('externalization.ITFSecurityForm.placeholder.continuityInterruptionRisk')}
              labelKey={lang === 'mne' ? 'name' : 'nameEn'}
              className='select'
              defaultValue={defaultData?.businessContinuityRiskLevel ? {
                  label: lang === 'mne' ? defaultData?.businessContinuityRiskLevel?.name : defaultData?.businessContinuityRiskLevel?.nameEn,
                  value: defaultData?.businessContinuityRiskLevel?.id,
                }
                : null}
              isDisabled={disabled} />
          </Col>
          <Col className='col-6 col-xl-3'>
            <label className='label w-100 mt-2'>
              {t('comments.comment')}
              <span className='optional register line-height'>
                  {t('common.optional')}
                </span>
            </label>
            <TextArea
              name='businessContinuityRiskLevelDescription'
              className={`form-control text-area `}
              placeholder={t('placeholder.comment')}
              disabled={disabled}
              defaultValue={defaultData?.businessContinuityRiskLevelDescription}
            />
          </Col>
          <Col className='col-6 col-xl-3'>
            <label className="label d-flex align-items-end w-100 mt-2">
              {t('externalization.riskProponentForm.file')}
              <span style={{minWidth: '94%'}} className="optional register line-height">{t('common.optional')} </span>
            </label>
            <FileUploadSection
              className={'fileName'}
              fieldName={'businessContinuityRiskLevel'}
              key={files?.businessContinuityRiskLevel?.id || 'no-file'}
              allowedFileTypes={allowedFileTypes}
              disabled={disabled}
              required={false}
              multiple={false}
              fetchedFiles={defaultData?.files?.businessContinuityRiskLevel ?
                {
                  fileName: defaultData?.files?.businessContinuityRiskLevel?.fileName,
                  id: defaultData?.files?.businessContinuityRiskLevel?.id
                } : [{ id: files?.businessContinuityRiskLevel?.id, fileName: files?.businessContinuityRiskLevel?.fileName }]}
              onDeleteFetchedFile={() => removeFile('businessContinuityRiskLevel')}
              onNewFilesChange={(newFiles) => handleFileUploadExternal(newFiles, 'businessContinuityRiskLevel', 'business-continuity-risk-level')}
              onFileDownload={(id, fileName) => handleDownload(defaultData?.files?.businessContinuityRiskLevel?.id, fileName)}
            />
          </Col>
        </Row>
        <Row>
          <Col className='col-6 col-xl-3'>
            <label className='label w-100 mt-2' htmlFor='regulatoryAndAuditAccessRiskLevel'>
              {t('externalization.ITFSecurityForm.supervision')}
              <span className="optional register line-height pt-1"><Tooltip
                title={t('externalization.ITFSecurityForm.supervisionTooltip')}
                overlayClassName="custom-tooltip"
                placement="top"><div style={{ cursor: 'default' }}><InfoCircleOutlined /></div></Tooltip></span></label>
            <SelectInfinite
              api='regulatory-and-audit-access-risk-levels'
              name='regulatoryAndAuditAccessRiskLevel'
              placeholder={t('externalization.ITFSecurityForm.placeholder.supervision')}
              labelKey={lang === 'mne' ? 'name' : 'nameEn'}
              className='select'
              defaultValue={defaultData?.regulatoryAndAuditAccessRiskLevel ? {
                  label: lang === 'mne' ? defaultData?.regulatoryAndAuditAccessRiskLevel?.name : defaultData?.regulatoryAndAuditAccessRiskLevel?.nameEn,
                  value: defaultData?.regulatoryAndAuditAccessRiskLevel?.id,
                }
                : null}
              isDisabled={disabled} />
          </Col>
          <Col className='col-6 col-xl-3'>
            <label className='label w-100 mt-2'>
              {t('comments.comment')}
              <span className='optional register line-height'>
                  {t('common.optional')}
                </span>
            </label>
            <TextArea
              name='regulatoryAndAuditAccessRiskLevelDescription'
              className={`form-control text-area `}
              placeholder={t('placeholder.comment')}
              disabled={disabled}
              defaultValue={defaultData?.regulatoryAndAuditAccessRiskLevelDescription}
            />
          </Col>
          <Col className='col-6 col-xl-3'>
            <label className="label d-flex align-items-end w-100 mt-2">
              {t('externalization.riskProponentForm.file')}
              <span style={{minWidth: '94%'}} className="optional register line-height">{t('common.optional')} </span>
            </label>
            <FileUploadSection
              className={'fileName'}
              fieldName={'regulatoryAndAuditAccessRiskLevel'}
              key={files?.regulatoryAndAuditAccessRiskLevel?.id || 'no-file'}
              allowedFileTypes={allowedFileTypes}
              disabled={disabled}
              required={false}
              multiple={false}
              fetchedFiles={defaultData?.files?.regulatoryAndAuditAccessRiskLevel ?
                {
                  fileName: defaultData?.files?.regulatoryAndAuditAccessRiskLevel?.fileName,
                  id: defaultData?.files?.regulatoryAndAuditAccessRiskLevel?.id
                } : [{ id: files?.regulatoryAndAuditAccessRiskLevel?.id, fileName: files?.regulatoryAndAuditAccessRiskLevel?.fileName }]}
              onDeleteFetchedFile={() => removeFile('regulatoryAndAuditAccessRiskLevel')}
              onNewFilesChange={(newFiles) => handleFileUploadExternal(newFiles, 'regulatoryAndAuditAccessRiskLevel', 'regulatory-and-audit-access-risk-level')}
              onFileDownload={(id, fileName) => handleDownload(defaultData?.files?.regulatoryAndAuditAccessRiskLevel?.id, fileName)}
            />
          </Col>
        </Row>
        <Row>
          <Col className='col-6 col-xl-3'>
            <label className='label w-100 mt-2' htmlFor='confidentialityAndDataProtectionRiskLevel'>
              {t('externalization.ITFSecurityForm.bankingSecretsDisclosion')}
              <span className="optional register line-height pt-1"><Tooltip
                title={t('externalization.ITFSecurityForm.bankingSecretsDisclosionTooltip')}
                overlayClassName="custom-tooltip"
                placement="top"><div style={{ cursor: 'default' }}><InfoCircleOutlined /></div></Tooltip></span></label>
            <SelectInfinite
              api='confidentiality-and-data-protection-risk-levels'
              name='confidentialityAndDataProtectionRiskLevel'
              placeholder={t('externalization.ITFSecurityForm.placeholder.bankingSecretsDisclosion')}
              labelKey={lang === 'mne' ? 'name' : 'nameEn'}
              className='select'
              defaultValue={defaultData?.confidentialityAndDataProtectionRiskLevel ? {
                  label: lang === 'mne' ? defaultData?.confidentialityAndDataProtectionRiskLevel?.name : defaultData?.confidentialityAndDataProtectionRiskLevel?.nameEn,
                  value: defaultData?.confidentialityAndDataProtectionRiskLevel?.id,
                }
                : null}
              isDisabled={disabled} />
          </Col>
          <Col className='col-6 col-xl-3'>
            <label className='label w-100 mt-2'>
              {t('comments.comment')}
              <span className='optional register line-height'>
                  {t('common.optional')}
                </span>
            </label>
            <TextArea
              name='confidentialityAndDataProtectionRiskLevelDescription'
              className={`form-control text-area `}
              placeholder={t('placeholder.comment')}
              disabled={disabled}
              defaultValue={defaultData?.confidentialityAndDataProtectionRiskLevelDescription}
            />
          </Col>
          <Col className='col-6 col-xl-3'>
            <label className="label d-flex align-items-end w-100 mt-2">
              {t('externalization.riskProponentForm.file')}
              <span style={{minWidth: '94%'}} className="optional register line-height">{t('common.optional')} </span>
            </label>
            <FileUploadSection
              className={'fileName'}
              fieldName={'confidentialityAndDataProtectionRiskLevel'}
              key={files?.confidentialityAndDataProtectionRiskLevel?.id || 'no-file'}
              allowedFileTypes={allowedFileTypes}
              disabled={disabled}
              required={false}
              multiple={false}
              fetchedFiles={defaultData?.files?.confidentialityAndDataProtectionRiskLevel ?
                {
                  fileName: defaultData?.files?.confidentialityAndDataProtectionRiskLevel?.fileName,
                  id: defaultData?.files?.confidentialityAndDataProtectionRiskLevel?.id
                } : [{ id: files?.confidentialityAndDataProtectionRiskLevel?.id, fileName: files?.confidentialityAndDataProtectionRiskLevel?.fileName }]}
              onDeleteFetchedFile={() => removeFile('confidentialityAndDataProtectionRiskLevel')}
              onNewFilesChange={(newFiles) => handleFileUploadExternal(newFiles, 'confidentialityAndDataProtectionRiskLevel', 'confidentiality-and-data-protection-risk-level')}
              onFileDownload={(id, fileName) => handleDownload(defaultData?.files?.confidentialityAndDataProtectionRiskLevel?.id, fileName)}
            />
          </Col>
        </Row>
        <Row>
          <Col className='col-6 col-xl-3'>
            <label className='label w-100 mt-2' htmlFor='dataLossAndUnauthorizedAccessRiskLevel'>
              {t('externalization.ITFSecurityForm.dataLossRisk')}
              <span className="optional register line-height pt-1"><Tooltip
                title={t('externalization.ITFSecurityForm.dataLossRiskTooltip')}
                overlayClassName="custom-tooltip"
                placement="top"><div style={{ cursor: 'default' }}><InfoCircleOutlined /></div></Tooltip></span></label>
            <SelectInfinite
              api='data-loss-and-unauthorized-access-risk-levels'
              name='dataLossAndUnauthorizedAccessRiskLevel'
              placeholder={t('externalization.ITFSecurityForm.placeholder.dataLossRisk')}
              labelKey={lang === 'mne' ? 'name' : 'nameEn'}
              className='select'
              defaultValue={defaultData?.dataLossAndUnauthorizedAccessRiskLevel ? {
                  label: lang === 'mne' ? defaultData?.dataLossAndUnauthorizedAccessRiskLevel?.name : defaultData?.dataLossAndUnauthorizedAccessRiskLevel?.nameEn,
                  value: defaultData?.dataLossAndUnauthorizedAccessRiskLevel?.id,
                }
                : null}
              isDisabled={disabled} />
          </Col>
          <Col className='col-6 col-xl-3'>
            <label className='label w-100 mt-2'>
              {t('comments.comment')}
              <span className='optional register line-height'>
                  {t('common.optional')}
                </span>
            </label>
            <TextArea
              name='dataLossAndUnauthorizedAccessRiskLevelDescription'
              className={`form-control text-area `}
              placeholder={t('placeholder.comment')}
              disabled={disabled}
              defaultValue={defaultData?.dataLossAndUnauthorizedAccessRiskLevelDescription}
            />
          </Col>
          <Col className='col-6 col-xl-3'>
            <label className="label d-flex align-items-end w-100 mt-2">
              {t('externalization.riskProponentForm.file')}
              <span style={{minWidth: '94%'}} className="optional register line-height">{t('common.optional')} </span>
            </label>
            <FileUploadSection
              className={'fileName'}
              fieldName={'dataLossAndUnauthorizedAccessRiskLevelFile'}
              key={files?.dataLossAndUnauthorizedAccessRiskLevelFile?.id || 'no-file'}
              allowedFileTypes={allowedFileTypes}
              disabled={disabled}
              required={false}
              multiple={false}
              fetchedFiles={defaultData?.files?.dataLossAndUnauthorizedAccessRiskLevelFile ?
                {
                  fileName: defaultData?.files?.dataLossAndUnauthorizedAccessRiskLevelFile?.fileName,
                  id: defaultData?.files?.dataLossAndUnauthorizedAccessRiskLevelFile?.id
                } : [{ id: files?.dataLossAndUnauthorizedAccessRiskLevelFile?.id, fileName: files?.dataLossAndUnauthorizedAccessRiskLevelFile?.fileName }]}
              onDeleteFetchedFile={() => removeFile('dataLossAndUnauthorizedAccessRiskLevelFile')}
              onNewFilesChange={(newFiles) => handleFileUploadExternal(newFiles, 'dataLossAndUnauthorizedAccessRiskLevelFile', 'data-loss-and-unauthorized-access-risk-level')}
              onFileDownload={(id, fileName) => handleDownload(defaultData?.files?.dataLossAndUnauthorizedAccessRiskLevelFile?.id, fileName)}
            />
          </Col>
        </Row>
        <Row>
          <Col className='col-6 col-xl-3'>
            <label className='label w-100 mt-2' htmlFor='serviceProviderReplacementFeasibilityLevel'>
              {t('externalization.ITFSecurityForm.serviceProviderSwitch')}
              <span className="optional register line-height pt-1"><Tooltip
                title={t('externalization.ITFSecurityForm.serviceProviderSwitchTooltip')}
                overlayClassName="custom-tooltip"
                placement="top"><div style={{ cursor: 'default' }}><InfoCircleOutlined /></div></Tooltip></span></label>
            <SelectInfinite
              api='service-provider-replacement-feasibility-levels'
              name='serviceProviderReplacementFeasibilityLevel'
              placeholder={t('externalization.ITFSecurityForm.placeholder.serviceProviderSwitch')}
              labelKey={lang === 'mne' ? 'name' : 'nameEn'}
              className='select'
              defaultValue={defaultData?.serviceProviderReplacementFeasibilityLevel ? {
                  label: lang === 'mne' ? defaultData?.serviceProviderReplacementFeasibilityLevel?.name : defaultData?.serviceProviderReplacementFeasibilityLevel?.nameEn,
                  value: defaultData?.serviceProviderReplacementFeasibilityLevel?.id,
                }
                : null}
              isDisabled={disabled} />
          </Col>
          <Col className='col-6 col-xl-3'>
            <label className='label w-100 mt-2'>
              {t('comments.comment')}
              <span className='optional register line-height'>
                  {t('common.optional')}
                </span>
            </label>
            <TextArea
              name='serviceProviderReplacementFeasibilityLevelDescription'
              className={`form-control text-area `}
              placeholder={t('placeholder.comment')}
              disabled={disabled}
              defaultValue={defaultData?.serviceProviderReplacementFeasibilityLevelDescription}
            />
          </Col>
          <Col className='col-6 col-xl-3'>
            <label className="label d-flex align-items-end w-100 mt-2">
              {t('externalization.riskProponentForm.file')}
              <span style={{minWidth: '94%'}} className="optional register line-height">{t('common.optional')} </span>
            </label>
            <FileUploadSection
              className={'fileName'}
              fieldName={'serviceProviderReplacementFeasibilityLevelFile'}
              key={files?.serviceProviderReplacementFeasibilityLevelFile?.id || 'no-file'}
              allowedFileTypes={allowedFileTypes}
              disabled={disabled}
              required={false}
              multiple={false}
              fetchedFiles={defaultData?.files?.serviceProviderReplacementFeasibilityLevelFile ?
                {
                  fileName: defaultData?.files?.serviceProviderReplacementFeasibilityLevelFile?.fileName,
                  id: defaultData?.files?.serviceProviderReplacementFeasibilityLevelFile?.id
                } : [{ id: files?.serviceProviderReplacementFeasibilityLevelFile?.id, fileName: files?.serviceProviderReplacementFeasibilityLevelFile?.fileName }]}
              onDeleteFetchedFile={() => removeFile('serviceProviderReplacementFeasibilityLevelFile')}
              onNewFilesChange={(newFiles) => handleFileUploadExternal(newFiles, 'serviceProviderReplacementFeasibilityLevelFile', 'service-provider-replacement-feasibility-risk-level')}
              onFileDownload={(id, fileName) => handleDownload(defaultData?.files?.serviceProviderReplacementFeasibilityLevelFile?.id, fileName)}
            />
          </Col>
        </Row>
        <Row>
          <Col className='col-6 col-xl-3'>
            <label className='label w-100 mt-2' htmlFor='serviceProviderDependencyLevel'>
              {t('externalization.ITFSecurityForm.serviceProviderDependency')}
              <span className="optional register line-height pt-1"><Tooltip
                title={t('externalization.ITFSecurityForm.serviceProviderDependencyTooltip')}
                overlayClassName="custom-tooltip"
                placement="top"><div style={{ cursor: 'default' }}><InfoCircleOutlined /></div></Tooltip></span></label>
            <SelectInfinite
              api='service-provider-dependency-levels'
              name='serviceProviderDependencyLevel'
              placeholder={t('externalization.ITFSecurityForm.placeholder.serviceProviderDependency')}
              labelKey={lang === 'mne' ? 'name' : 'nameEn'}
              className='select'
              defaultValue={defaultData?.serviceProviderDependencyLevel ? {
                  label: lang === 'mne' ? defaultData?.serviceProviderDependencyLevel?.name : defaultData?.serviceProviderDependencyLevel?.nameEn,
                  value: defaultData?.serviceProviderDependencyLevel?.id,
                }
                : null}
              isDisabled={disabled} />
          </Col>
          <Col className='col-6 col-xl-3'>
            <label className='label w-100 mt-2'>
              {t('comments.comment')}
              <span className='optional register line-height'>
                  {t('common.optional')}
                </span>
            </label>
            <TextArea
              name='serviceProviderDependencyLevelDescription'
              className={`form-control text-area `}
              placeholder={t('placeholder.comment')}
              disabled={disabled}
              defaultValue={defaultData?.serviceProviderDependencyLevelDescription}
            />
          </Col>
          <Col className='col-6 col-xl-3'>
            <label className="label d-flex align-items-end w-100 mt-2">
              {t('externalization.riskProponentForm.file')}
              <span style={{minWidth: '94%'}} className="optional register line-height">{t('common.optional')} </span>
            </label>
            <FileUploadSection
              className={'fileName'}
              fieldName={'serviceProviderDependencyLevelFile'}
              key={files?.serviceProviderDependencyLevelFile?.id || 'no-file'}
              allowedFileTypes={allowedFileTypes}
              disabled={disabled}
              required={false}
              multiple={false}
              fetchedFiles={defaultData?.files?.serviceProviderDependencyLevelFile ?
                {
                  fileName: defaultData?.files?.serviceProviderDependencyLevelFile?.fileName,
                  id: defaultData?.files?.serviceProviderDependencyLevelFile?.id
                } : [{ id: files?.serviceProviderDependencyLevelFile?.id, fileName: files?.serviceProviderDependencyLevelFile?.fileName }]}
              onDeleteFetchedFile={() => removeFile('serviceProviderDependencyLevelFile')}
              onNewFilesChange={(newFiles) => handleFileUploadExternal(newFiles, 'serviceProviderDependencyLevelFile', 'service-provider-dependency-risk-level')}
              onFileDownload={(id, fileName) => handleDownload(defaultData?.files?.serviceProviderDependencyLevelFile?.id, fileName)}
            />
          </Col>
        </Row>
        <Row>
          <Col className='col-6 col-xl-3'>
            <label className='label w-100 mt-2' htmlFor='concentrationRiskLevel'>
              {t('externalization.ITFSecurityForm.concentrationRisk')}
              <span className="optional register line-height pt-1"><Tooltip
                title={t('externalization.ITFSecurityForm.concentrationRiskTooltip')}
                overlayClassName="custom-tooltip"
                placement="top"><div style={{ cursor: 'default' }}><InfoCircleOutlined /></div></Tooltip></span></label>
            <SelectInfinite
              api='concentration-risk-levels'
              name='concentrationRiskLevel'
              placeholder={t('externalization.ITFSecurityForm.placeholder.concentrationRisk')}
              labelKey={lang === 'mne' ? 'name' : 'nameEn'}
              className='select'
              defaultValue={defaultData?.concentrationRiskLevel ? {
                  label: lang === 'mne' ? defaultData?.concentrationRiskLevel?.name : defaultData?.concentrationRiskLevel?.nameEn,
                  value: defaultData?.concentrationRiskLevel?.id,
                }
                : null}
              isDisabled={disabled} />
          </Col>
          <Col className='col-6 col-xl-3'>
            <label className='label w-100 mt-2'>
              {t('comments.comment')}
              <span className='optional register line-height'>
                  {t('common.optional')}
                </span>
            </label>
            <TextArea
              name='concentrationRiskLevelDescription'
              className={`form-control text-area `}
              placeholder={t('placeholder.comment')}
              disabled={disabled}
              defaultValue={defaultData?.concentrationRiskLevelDescription}
            />
          </Col>
          <Col className='col-6 col-xl-3'>
            <label className="label d-flex align-items-end w-100 mt-2">
              {t('externalization.riskProponentForm.file')}
              <span style={{minWidth: '94%'}} className="optional register line-height">{t('common.optional')} </span>
            </label>
            <FileUploadSection
              className={'fileName'}
              fieldName={'concentrationRiskLevelFile'}
              key={files?.concentrationRiskLevelFile?.id || 'no-file'}
              allowedFileTypes={allowedFileTypes}
              disabled={disabled}
              required={false}
              multiple={false}
              fetchedFiles={defaultData?.files?.concentrationRiskLevelFile ?
                {
                  fileName: defaultData?.files?.concentrationRiskLevelFile?.fileName,
                  id: defaultData?.files?.concentrationRiskLevelFile?.id
                } : [{ id: files?.concentrationRiskLevelFile?.id, fileName: files?.concentrationRiskLevelFile?.fileName }]}
              onDeleteFetchedFile={() => removeFile('concentrationRiskLevelFile')}
              onNewFilesChange={(newFiles) => handleFileUploadExternal(newFiles, 'concentrationRiskLevelFile', 'concentration-risk-level')}
              onFileDownload={(id, fileName) => handleDownload(defaultData?.files?.concentrationRiskLevelFile?.id, fileName)}
            />
          </Col>
        </Row>
        <Row>
          <Col className='col-6 col-xl-3'>
            <label className='label w-100 mt-2' htmlFor='changeManagementRiskLevel'>
              {t('externalization.ITFSecurityForm.inadequateChangeManagement')}
              <span className="optional register line-height pt-1"><Tooltip
                title={t('externalization.ITFSecurityForm.inadequateChangeManagementTooltip')}
                overlayClassName="custom-tooltip"
                placement="top"><div style={{ cursor: 'default' }}><InfoCircleOutlined /></div></Tooltip></span></label>
            <SelectInfinite
              api='change-management-risk-levels'
              name='changeManagementRiskLevel'
              placeholder={t('externalization.ITFSecurityForm.placeholder.inadequateChangeManagement')}
              labelKey={lang === 'mne' ? 'name' : 'nameEn'}
              className='select'
              defaultValue={defaultData?.changeManagementRiskLevel ? {
                  label: lang === 'mne' ? defaultData?.changeManagementRiskLevel?.name : defaultData?.changeManagementRiskLevel?.nameEn,
                  value: defaultData?.changeManagementRiskLevel?.id,
                }
                : null}
              isDisabled={disabled} />
          </Col>
          <Col className='col-6 col-xl-3'>
            <label className='label w-100 mt-2'>
              {t('comments.comment')}
              <span className='optional register line-height'>
                  {t('common.optional')}
                </span>
            </label>
            <TextArea
              name='changeManagementRiskLevelDescription'
              className={`form-control text-area `}
              placeholder={t('placeholder.comment')}
              disabled={disabled}
              defaultValue={defaultData?.changeManagementRiskLevelDescription}
            />
          </Col>
          <Col className='col-6 col-xl-3'>
            <label className="label d-flex align-items-end w-100 mt-2">
              {t('externalization.riskProponentForm.file')}
              <span style={{minWidth: '94%'}} className="optional register line-height">{t('common.optional')} </span>
            </label>
            <FileUploadSection
              className={'fileName'}
              fieldName={'changeManagementRiskLevelFile'}
              key={files?.changeManagementRiskLevelFile?.id || 'no-file'}
              allowedFileTypes={allowedFileTypes}
              disabled={disabled}
              required={false}
              multiple={false}
              fetchedFiles={defaultData?.files?.changeManagementRiskLevelFile ?
                {
                  fileName: defaultData?.files?.changeManagementRiskLevelFile?.fileName,
                  id: defaultData?.files?.changeManagementRiskLevelFile?.id
                } : [{ id: files?.changeManagementRiskLevelFile?.id, fileName: files?.changeManagementRiskLevelFile?.fileName }]}
              onDeleteFetchedFile={() => removeFile('changeManagementRiskLevelFile')}
              onNewFilesChange={(newFiles) => handleFileUploadExternal(newFiles, 'changeManagementRiskLevelFile', 'change-management-risk-level')}
              onFileDownload={(id, fileName) => handleDownload(defaultData?.files?.changeManagementRiskLevelFile?.id, fileName)}
            />
          </Col>
        </Row>
        <Row>
          <Col className='col-6 col-xl-3'>
            <label className='label w-100 mt-2' htmlFor='thirdPartyAccessControlRiskLevel'>
              {t('externalization.ITFSecurityForm.bankNetworkIntrusion')}
              <span className="optional register line-height pt-1"><Tooltip
                title={t('externalization.ITFSecurityForm.bankNetworkIntrusionTooltip')}
                overlayClassName="custom-tooltip"
                placement="top"><div style={{ cursor: 'default' }}><InfoCircleOutlined /></div></Tooltip></span></label>
            <SelectInfinite
              api='third-party-access-control-risk-levels'
              name='thirdPartyAccessControlRiskLevel'
              placeholder={t('externalization.ITFSecurityForm.placeholder.bankNetworkIntrusion')}
              labelKey={lang === 'mne' ? 'name' : 'nameEn'}
              className='select'
              defaultValue={defaultData?.thirdPartyAccessControlRiskLevel ? {
                  label: lang === 'mne' ? defaultData?.thirdPartyAccessControlRiskLevel?.name : defaultData?.thirdPartyAccessControlRiskLevel?.nameEn,
                  value: defaultData?.thirdPartyAccessControlRiskLevel?.id,
                }
                : null}
              isDisabled={disabled} />
          </Col>
          <Col className='col-6 col-xl-3'>
            <label className='label w-100 mt-2'>
              {t('comments.comment')}
              <span className='optional register line-height'>
                  {t('common.optional')}
                </span>
            </label>
            <TextArea
              name='thirdPartyAccessControlRiskLevelDescription'
              className={`form-control text-area `}
              placeholder={t('placeholder.comment')}
              disabled={disabled}
              defaultValue={defaultData?.thirdPartyAccessControlRiskLevelDescription}
            />
          </Col>
          <Col className='col-6 col-xl-3'>
            <label className="label d-flex align-items-end w-100 mt-2">
              {t('externalization.riskProponentForm.file')}
              <span style={{minWidth: '94%'}} className="optional register line-height">{t('common.optional')} </span>
            </label>
            <FileUploadSection
              className={'fileName'}
              fieldName={'thirdPartyAccessControlRiskLevelFile'}
              key={files?.thirdPartyAccessControlRiskLevelFile?.id || 'no-file'}
              allowedFileTypes={allowedFileTypes}
              disabled={disabled}
              required={false}
              multiple={false}
              fetchedFiles={defaultData?.files?.thirdPartyAccessControlRiskLevelFile ?
                {
                  fileName: defaultData?.files?.thirdPartyAccessControlRiskLevelFile?.fileName,
                  id: defaultData?.files?.thirdPartyAccessControlRiskLevelFile?.id
                } : [{ id: files?.thirdPartyAccessControlRiskLevelFile?.id, fileName: files?.thirdPartyAccessControlRiskLevelFile?.fileName }]}
              onDeleteFetchedFile={() => removeFile('thirdPartyAccessControlRiskLevelFile')}
              onNewFilesChange={(newFiles) => handleFileUploadExternal(newFiles, 'thirdPartyAccessControlRiskLevelFile', 'third-party-access-control-risk-level')}
              onFileDownload={(id, fileName) => handleDownload(defaultData?.files?.thirdPartyAccessControlRiskLevelFile?.id, fileName)}
            />
          </Col>
        </Row>
        <Row>
          <Col className='col-6 col-xl-3'>
            <label className='label w-100 mt-2' htmlFor='flexibilityAndTechnicalLimitationRiskLevel'>
              {t('externalization.ITFSecurityForm.flexibilityLoss')}
              <span className="optional register line-height pt-1"><Tooltip
                title={t('externalization.ITFSecurityForm.flexibilityLossTooltip')}
                overlayClassName="custom-tooltip"
                placement="top"><div style={{ cursor: 'default' }}><InfoCircleOutlined /></div></Tooltip></span></label>
            <SelectInfinite
              api='flexibility-and-technical-limitation-risk-levels'
              name='flexibilityAndTechnicalLimitationRiskLevel'
              placeholder={t('externalization.ITFSecurityForm.placeholder.flexibilityLoss')}
              labelKey={lang === 'mne' ? 'name' : 'nameEn'}
              className='select'
              defaultValue={defaultData?.flexibilityAndTechnicalLimitationRiskLevel ? {
                  label: lang === 'mne' ? defaultData?.flexibilityAndTechnicalLimitationRiskLevel?.name : defaultData?.flexibilityAndTechnicalLimitationRiskLevel?.nameEn,
                  value: defaultData?.flexibilityAndTechnicalLimitationRiskLevel?.id,
                }
                : null}
              isDisabled={disabled} />
          </Col>
          <Col className='col-6 col-xl-3'>
            <label className='label w-100 mt-2'>
              {t('comments.comment')}
              <span className='optional register line-height'>
                  {t('common.optional')}
                </span>
            </label>
            <TextArea
              name='flexibilityAndTechnicalLimitationRiskLevelDescription'
              className={`form-control text-area `}
              placeholder={t('placeholder.comment')}
              disabled={disabled}
              defaultValue={defaultData?.flexibilityAndTechnicalLimitationRiskLevelDescription}
            />
          </Col>
          <Col className='col-6 col-xl-3'>
            <label className="label d-flex align-items-end w-100 mt-2">
              {t('externalization.riskProponentForm.file')}
              <span style={{minWidth: '94%'}} className="optional register line-height">{t('common.optional')} </span>
            </label>
            <FileUploadSection
              className={'fileName'}
              fieldName={'flexibilityAndTechnicalLimitationRiskLevelFile'}
              key={files?.flexibilityAndTechnicalLimitationRiskLevelFile?.id || 'no-file'}
              allowedFileTypes={allowedFileTypes}
              disabled={disabled}
              required={false}
              multiple={false}
              fetchedFiles={defaultData?.files?.flexibilityAndTechnicalLimitationRiskLevelFile ?
                {
                  fileName: defaultData?.files?.flexibilityAndTechnicalLimitationRiskLevelFile?.fileName,
                  id: defaultData?.files?.flexibilityAndTechnicalLimitationRiskLevelFile?.id
                } : [{ id: files?.flexibilityAndTechnicalLimitationRiskLevelFile?.id, fileName: files?.flexibilityAndTechnicalLimitationRiskLevelFile?.fileName }]}
              onDeleteFetchedFile={() => removeFile('flexibilityAndTechnicalLimitationRiskLevelFile')}
              onNewFilesChange={(newFiles) => handleFileUploadExternal(newFiles, 'flexibilityAndTechnicalLimitationRiskLevelFile', 'flexibility-and-technical-limitation-risk-level')}
              onFileDownload={(id, fileName) => handleDownload(defaultData?.files?.flexibilityAndTechnicalLimitationRiskLevelFile?.id, fileName)}
            />
          </Col>
        </Row>
        <Row>
          <Col className='col-6 col-xl-3'>
            <label className='label w-100 mt-2' htmlFor='technologyAdaptabilityRiskLevel'>
              {t('externalization.ITFSecurityForm.serviceProviderAdaptability')}
              <span className="optional register line-height pt-1"><Tooltip
                title={t('externalization.ITFSecurityForm.serviceProviderAdaptabilityTooltip')}
                overlayClassName="custom-tooltip"
                placement="top"><div style={{ cursor: 'default' }}><InfoCircleOutlined /></div></Tooltip></span></label>
            <SelectInfinite
              api='technology-adaptability-risk-levels'
              name='technologyAdaptabilityRiskLevel'
              placeholder={t('externalization.ITFSecurityForm.placeholder.serviceProviderAdaptability')}
              labelKey={lang === 'mne' ? 'name' : 'nameEn'}
              className='select'
              defaultValue={defaultData?.technologyAdaptabilityRiskLevel ? {
                  label: lang === 'mne' ? defaultData?.technologyAdaptabilityRiskLevel?.name : defaultData?.technologyAdaptabilityRiskLevel?.nameEn,
                  value: defaultData?.technologyAdaptabilityRiskLevel?.id,
                }
                : null}
              isDisabled={disabled} />
          </Col>
          <Col className='col-6 col-xl-3'>
            <label className='label w-100 mt-2'>
              {t('comments.comment')}
              <span className='optional register line-height'>
                  {t('common.optional')}
                </span>
            </label>
            <TextArea
              name='technologyAdaptabilityRiskLevelDescription'
              className={`form-control text-area `}
              placeholder={t('placeholder.comment')}
              disabled={disabled}
              defaultValue={defaultData?.technologyAdaptabilityRiskLevelDescription}
            />
          </Col>
          <Col className='col-6 col-xl-3'>
            <label className="label d-flex align-items-end w-100 mt-2">
              {t('externalization.riskProponentForm.file')}
              <span style={{minWidth: '94%'}} className="optional register line-height">{t('common.optional')} </span>
            </label>
            <FileUploadSection
              className={'fileName'}
              fieldName={'technologyAdaptabilityRiskLevelFile'}
              key={files?.technologyAdaptabilityRiskLevelFile?.id || 'no-file'}
              allowedFileTypes={allowedFileTypes}
              disabled={disabled}
              required={false}
              multiple={false}
              fetchedFiles={defaultData?.files?.technologyAdaptabilityRiskLevelFile ?
                {
                  fileName: defaultData?.files?.technologyAdaptabilityRiskLevelFile?.fileName,
                  id: defaultData?.files?.technologyAdaptabilityRiskLevelFile?.id
                } : [{ id: files?.technologyAdaptabilityRiskLevelFile?.id, fileName: files?.technologyAdaptabilityRiskLevelFile?.fileName }]}
              onDeleteFetchedFile={() => removeFile('technologyAdaptabilityRiskLevelFile')}
              onNewFilesChange={(newFiles) => handleFileUploadExternal(newFiles, 'technologyAdaptabilityRiskLevelFile', 'technology-adaptability-risk-level')}
              onFileDownload={(id, fileName) => handleDownload(defaultData?.files?.technologyAdaptabilityRiskLevelFile?.id, fileName)}
            />
          </Col>
        </Row>
        <Row>
          <Col className='col-6 col-xl-3'>
            <label className='label w-100 mt-2' htmlFor='serviceMonitoringAndMaintenanceRiskLevel'>
              {t('externalization.ITFSecurityForm.impossibilityOfMonitoringProvision')}
              <span className="optional register line-height pt-1"><Tooltip
                title={t('externalization.ITFSecurityForm.impossibilityOfMonitoringProvisionTooltip')}
                overlayClassName="custom-tooltip"
                placement="top"><div style={{ cursor: 'default' }}><InfoCircleOutlined /></div></Tooltip></span></label>
            <SelectInfinite
              api='service-monitoring-and-maintenance-risk-levels'
              name='serviceMonitoringAndMaintenanceRiskLevel'
              placeholder={t('externalization.ITFSecurityForm.placeholder.impossibilityOfMonitoringProvision')}
              labelKey={lang === 'mne' ? 'name' : 'nameEn'}
              className='select'
              defaultValue={defaultData?.serviceMonitoringAndMaintenanceRiskLevel ? {
                  label: lang === 'mne' ? defaultData?.serviceMonitoringAndMaintenanceRiskLevel?.name : defaultData?.serviceMonitoringAndMaintenanceRiskLevel?.nameEn,
                  value: defaultData?.serviceMonitoringAndMaintenanceRiskLevel?.id,
                }
                : null}
              isDisabled={disabled} />
          </Col>
          <Col className='col-6 col-xl-3'>
            <label className='label w-100 mt-2'>
              {t('comments.comment')}
              <span className='optional register line-height'>
                  {t('common.optional')}
                </span>
            </label>
            <TextArea
              name='serviceMonitoringAndMaintenanceRiskLevelDescription'
              className={`form-control text-area `}
              placeholder={t('placeholder.comment')}
              disabled={disabled}
              defaultValue={defaultData?.serviceMonitoringAndMaintenanceRiskLevelDescription}
            />
          </Col>
          <Col className='col-6 col-xl-3'>
            <label className="label d-flex align-items-end w-100 mt-2">
              {t('externalization.riskProponentForm.file')}
              <span style={{minWidth: '94%'}} className="optional register line-height">{t('common.optional')} </span>
            </label>
            <FileUploadSection
              className={'fileName'}
              fieldName={'serviceMonitoringAndMaintenanceRiskLevelFile'}
              key={files?.serviceMonitoringAndMaintenanceRiskLevelFile?.id || 'no-file'}
              allowedFileTypes={allowedFileTypes}
              disabled={disabled}
              required={false}
              multiple={false}
              fetchedFiles={defaultData?.files?.serviceMonitoringAndMaintenanceRiskLevelFile ?
                {
                  fileName: defaultData?.files?.serviceMonitoringAndMaintenanceRiskLevelFile?.fileName,
                  id: defaultData?.files?.serviceMonitoringAndMaintenanceRiskLevelFile?.id
                } : [{ id: files?.serviceMonitoringAndMaintenanceRiskLevelFile?.id, fileName: files?.serviceMonitoringAndMaintenanceRiskLevelFile?.fileName }]}
              onDeleteFetchedFile={() => removeFile('serviceMonitoringAndMaintenanceRiskLevelFile')}
              onNewFilesChange={(newFiles) => handleFileUploadExternal(newFiles, 'serviceMonitoringAndMaintenanceRiskLevelFile', 'service-monitoring-and-maintenance-risk-level')}
              onFileDownload={(id, fileName) => handleDownload(defaultData?.files?.serviceMonitoringAndMaintenanceRiskLevelFile?.id, fileName)}
            />
          </Col>
        </Row>
        <Row>
          <Col className='col-6 col-xl-3'>
            <label className='label w-100 mt-2' htmlFor='technicalOversightFeasibilityRiskLevel'>
              {t('externalization.ITFSecurityForm.riskQualitySupervision')}
              <span className="optional register line-height pt-1"><Tooltip
                title={t('externalization.ITFSecurityForm.riskQualitySupervisionTooltip')}
                overlayClassName="custom-tooltip"
                placement="top"><div style={{ cursor: 'default' }}><InfoCircleOutlined /></div></Tooltip></span></label>
            <SelectInfinite
              api='technical-oversight-feasibility-risk-levels'
              name='technicalOversightFeasibilityRiskLevel'
              placeholder={t('externalization.ITFSecurityForm.placeholder.riskQualitySupervision')}
              labelKey={lang === 'mne' ? 'name' : 'nameEn'}
              className='select'
              defaultValue={defaultData?.technicalOversightFeasibilityRiskLevel ? {
                  label: lang === 'mne' ? defaultData?.technicalOversightFeasibilityRiskLevel?.name : defaultData?.technicalOversightFeasibilityRiskLevel?.nameEn,
                  value: defaultData?.technicalOversightFeasibilityRiskLevel?.id,
                }
                : null}
              isDisabled={disabled} />
          </Col>
          <Col className='col-6 col-xl-3'>
            <label className='label w-100 mt-2'>
              {t('comments.comment')}
              <span className='optional register line-height'>
                  {t('common.optional')}
                </span>
            </label>
            <TextArea
              name='technicalOversightFeasibilityRiskLevelDescription'
              className={`form-control text-area `}
              placeholder={t('placeholder.comment')}
              disabled={disabled}
              defaultValue={defaultData?.technicalOversightFeasibilityRiskLevelDescription}
            />
          </Col>
          <Col className='col-6 col-xl-3'>
            <label className="label d-flex align-items-end w-100 mt-2">
              {t('externalization.riskProponentForm.file')}
              <span style={{minWidth: '94%'}} className="optional register line-height">{t('common.optional')} </span>
            </label>
            <FileUploadSection
              className={'fileName'}
              fieldName={'technicalOversightFeasibilityRiskLevelFile'}
              key={files?.technicalOversightFeasibilityRiskLevelFile?.id || 'no-file'}
              allowedFileTypes={allowedFileTypes}
              disabled={disabled}
              required={false}
              multiple={false}
              fetchedFiles={defaultData?.files?.technicalOversightFeasibilityRiskLevelFile ?
                {
                  fileName: defaultData?.files?.technicalOversightFeasibilityRiskLevelFile?.fileName,
                  id: defaultData?.files?.technicalOversightFeasibilityRiskLevelFile?.id
                } : [{ id: files?.technicalOversightFeasibilityRiskLevelFile?.id, fileName: files?.technicalOversightFeasibilityRiskLevelFile?.fileName }]}
              onDeleteFetchedFile={() => removeFile('technicalOversightFeasibilityRiskLevelFile')}
              onNewFilesChange={(newFiles) => handleFileUploadExternal(newFiles, 'technicalOversightFeasibilityRiskLevelFile', 'technical-oversight-feasibility-risk-level')}
              onFileDownload={(id, fileName) => handleDownload(defaultData?.files?.technicalOversightFeasibilityRiskLevelFile?.id, fileName)}
            />
          </Col>
        </Row>
        <Row>
          <Col className='col-6 col-xl-3'>
            <label className='label w-100 mt-2' htmlFor='itfSecurityOverallRiskAssessmentLevel'>
              {t('externalization.riskProponentForm.riskAssessment')}
            </label>
            <SelectInfinite
              options={totalRiskAssessment}
              name='itfSecurityOverallRiskAssessmentLevel'
              labelKey={lang === 'mne' ? 'name' : 'nameEn'}
              className='select'
              isDisabled={true}
              placeholder={''}
              styles={customStyles}
              defaultValue={
                defaultData?.itfSecurityOverallRiskAssessmentLevel?.id
                  ? {
                    value: defaultData?.itfSecurityOverallRiskAssessmentLevel?.id,
                    label:
                      lang === 'mne'
                        ? defaultData?.itfSecurityOverallRiskAssessmentLevel?.name
                        : defaultData?.itfSecurityOverallRiskAssessmentLevel?.nameEn,
                  }
                  : null
              }
            />
          </Col>
          <Col className='col-6 col-xl-3'>
            <label className='label w-100 mt-2'>
              {t('externalization.riskProponentForm.riskDesc')}
            </label>
            <textarea
              key={riskDescription}
              value={riskDescription?.label}
              type='text'
              defaultValue={lang === 'mne' ? defaultData?.itfSecurityOverallRiskAssessmentLevel?.description : defaultData?.itfSecurityOverallRiskAssessmentLevel?.descriptionEn}
              disabled={true}
              rows={4} />
          </Col>
          <Col className='col-6 col-xl-3'>
            <label className='label w-100 mt-2'>
              {t('comments.comment')}
              <span className='optional register line-height'>
                  {t('common.optional')}
                </span>
            </label>
            <TextArea
              name='comment'
              className={`form-control text-area `}
              placeholder={t('placeholder.comment')}
              disabled={disabled}
              defaultValue={defaultData?.comment}
            />
          </Col>
          <Col className='col-6 col-xl-3'>
            <label className='label w-100 mt-2'>
              {t('externalization.ITFSecurityForm.answersOnQuestions')}
              <span className='optional register line-height'>{t('common.optional')}</span>
            </label>
            <SelectList
              name="answers678CoCreatedWithProposer"
              className="select"
              options={yesNoOptions}
              placeholder={t('externalization.ITFSecurityForm.placeholder.answersOnQuestions')}
              isClearable={true}
              isDisabled={disabled}
              defaultValue={
                typeof defaultData?.answers678CoCreatedWithProposer === 'boolean'
                  ? yesNoOptions.find(opt => opt.value === defaultData?.answers678CoCreatedWithProposer)
                  : null
              }
            />
          </Col>
            </Row>
            <Row className={'pb-5'}>
              <Col className='col-6 col-xl-3'>
                <label className='label w-100 mt-2'>
                  {t('externalization.riskProponentForm.analysisDoneBy')}
                </label>
                <InputText
                  type="text"
                  name="userInCharge"
                  className="form-control input-field"
                  disabled={true}
                  id="userInCharge"
                  defaultValue={externalizationFormConfigData?.defaultDepartment?.userInChargeForExternalizationFullName}
                />
              </Col>
              <Col className='col-6 col-xl-3'>
                {externalizationFormConfigData?.defaultDepartment?.deputyUserInChargeForExternalizationFullName && <>
                  <label className="label w-100 mt-2">{t('departments.userInChargeReplacementForExternalization')}</label>
                  <InputText
                    type="text"
                    name="userInChargeDeputy"
                    className="form-control input-field"
                    disabled={true}
                    id="userInCharge"
                    defaultValue={externalizationFormConfigData?.defaultDepartment?.deputyUserInChargeForExternalizationFullName}
                  /></>}
              </Col>
              <Col className='col-6 col-xl-3'>
              <label className='label w-100 mt-2'>
                  {t('externalization.riskProponentForm.verificationDoneBy')}
                </label>
                <InputText
                  type="text"
                  name="responsibleUser"
                  className="form-control input-field"
                  disabled={true}
                  id="responsibleUser"
                  defaultValue={externalizationFormConfigData?.defaultDepartment?.userResponsibleForExternalizationFullName}
                />
              </Col>
              <Col className='col-6 col-xl-3'>
                {edit && <>  <label className="label w-100 mt-2">{t('externalization.verificationStatus')}</label>
                  <InputText
                    name="verificationStatus"
                    type="text"
                    className="form-control input-field"
                    placeholder={t( 'externalization.placeholder.verificationStatus')}
                    disabled={true}
                    defaultValue={statusesOfVerification.find(
                      (status) => status.value === verificationStatus)?.label}
                  /></>}
              </Col>
        </Row>
        {(!edit || (edit && !disabled)) && isUserReviewer(externalizationConfigData, user, 'itfSecurityForm') &&<Row className='mt-5 form-footer mb-3'>
          <button
            className='secondary-btn'
            type='reset'
            onClick={handleCancelExternalization}>
            {t('buttons.cancel')}
          </button>
          <button className='primary-btn' disabled={disabled}>{t('buttons.save')}</button>
        </Row>}
      </form>
    </FormProvider>
    <VerifyExternalizationModal
      open={verifyModalOpen}
      formType={externalizationFormConfigData?.formKey}
      formId={defaultData?.id ? defaultData?.id : itfFormId}
      isOpen={setVerifyModalOpen}
    />
  </>);
}
export default ITFSecurity;